var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 2.08337C11.7853 2.08337 14.5835 4.88159 14.5835 8.33337C14.5835 9.7585 14.1065 11.0722 13.3035 12.1236L17.2561 16.0775C17.5815 16.4029 17.5815 16.9305 17.2561 17.256C16.9557 17.5564 16.483 17.5795 16.1561 17.3253L16.0776 17.256L12.1237 13.3034C11.0723 14.1064 9.75862 14.5834 8.3335 14.5834C4.88172 14.5834 2.0835 11.7852 2.0835 8.33337C2.0835 4.88159 4.88172 2.08337 8.3335 2.08337ZM8.3335 3.75004C5.80219 3.75004 3.75016 5.80207 3.75016 8.33337C3.75016 10.8647 5.80219 12.9167 8.3335 12.9167C10.8648 12.9167 12.9168 10.8647 12.9168 8.33337C12.9168 5.80207 10.8648 3.75004 8.3335 3.75004Z",
    fill: "#051D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.ed254939b2de71b393708171ad895dbb.svg";
export { ForwardRef as ReactComponent };